/**
 * @generated SignedSource<<0b56b46ffbfa38cbe0edb749efc809c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "CNY" | "EUR" | "GBP" | "JPY" | "NZD" | "SEK" | "USD";
export type organizationSettingsQuery$variables = {
  slug: string;
};
export type organizationSettingsQuery$data = {
  readonly organization: {
    readonly currency: Currency;
  } | null | undefined;
};
export type organizationSettingsQuery = {
  response: organizationSettingsQuery$data;
  variables: organizationSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "organizationSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "organizationSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0100049ccb484b5e615e124d35cead11",
    "id": null,
    "metadata": {},
    "name": "organizationSettingsQuery",
    "operationKind": "query",
    "text": "query organizationSettingsQuery(\n  $slug: String!\n) {\n  organization(slug: $slug) {\n    currency\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6f26d46c173ff90ba63de22ceb2d05e2";

export default node;
